import styled from 'styled-components';

export const GamedayWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    align-items: stretch;
    flex: 1 1 100%;
`;
